import { render } from "./UserHistoryPassStatusBox.vue?vue&type=template&id=3218b5a3"
import script from "./UserHistoryPassStatusBox.vue?vue&type=script&lang=js"
export * from "./UserHistoryPassStatusBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__